export const getBase64File = (base64) => {
  if (!base64) return null; // Handle null or undefined input

  if (base64.startsWith("JVBER")) {
    console.log("Detected PDF file.");
    return `data:application/pdf;base64,${base64}`; // PDF
  }

  if (base64.startsWith("/9j/") || base64.startsWith("/AAAB")) {
    return `data:image/jpeg;base64,${base64}`; // JPEG/JPG
  }

  if (base64.startsWith("iVBOR")) {
    return `data:image/png;base64,${base64}`; // PNG
  }

  if (base64.startsWith("R0lGOD")) {
    return `data:image/gif;base64,${base64}`; // GIF
  }

  if (base64.startsWith("UklGR")) {
    return `data:image/webp;base64,${base64}`; // WebP
  }

  if (base64.startsWith("AAABAAEAAwAA")) {
    return `data:image/bmp;base64,${base64}`; // BMP
  }

  if (base64.startsWith("SUQz")) {
    return `data:image/ico;base64,${base64}`; // ICO
  }

  if (base64.startsWith("PHN2")) {
    return `data:image/svg+xml;base64,${base64}`; // SVG
  }

  if (base64.startsWith("SUkqA") || base64.startsWith("TU0AK")) {
    return `data:image/tiff;base64,${base64}`; // TIFF
  }

  if (base64.startsWith("APNG")) {
    return `data:image/apng;base64,${base64}`; // APNG
  }

  if (base64.startsWith("AAABAAIAAQI")) {
    return `data:image/cur;base64,${base64}`; // CUR
  }

  return null; // Unsupported type
};

export const getBase64FileName = (base64) => {
  if (!base64) return null; // Handle null or undefined input

  let extension = "";

  if (base64.startsWith("JVBER")) {
    console.log("Detected PDF file.");
    extension = "pdf";
  } else if (base64.startsWith("/9j/") || base64.startsWith("/AAAB")) {
    extension = "jpg"; // JPEG/JPG
  } else if (base64.startsWith("iVBOR")) {
    extension = "png"; // PNG
  } else if (base64.startsWith("R0lGOD")) {
    extension = "gif"; // GIF
  } else if (base64.startsWith("UklGR")) {
    extension = "webp"; // WebP
  } else if (base64.startsWith("AAABAAEAAwAA")) {
    extension = "bmp"; // BMP
  } else if (base64.startsWith("SUQz")) {
    extension = "ico"; // ICO
  } else if (base64.startsWith("PHN2")) {
    extension = "svg"; // SVG
  } else if (base64.startsWith("SUkqA") || base64.startsWith("TU0AK")) {
    extension = "tiff"; // TIFF
  } else if (base64.startsWith("APNG")) {
    extension = "apng"; // APNG
  } else if (base64.startsWith("AAABAAIAAQI")) {
    extension = "cur"; // CUR
  } else {
    return null; // Unsupported type
  }

  const timestamp = Date.now();
  return `file_${timestamp}.${extension}`;
};

export const getBase64FileSize = (base64) => {
  if (!base64) return "0 B";

  const padding = (base64.match(/=+$/) || [""])[0].length;
  const sizeInBytes = Math.ceil((base64.length * 3) / 4) - padding;

  if (sizeInBytes < 1024) {
    return `${sizeInBytes} B`;
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`;
  } else if (sizeInBytes < 1024 * 1024 * 1024) {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  } else {
    return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
};

export const getBase64FileType = (base64) => {
  if (!base64) return null;

  if (base64.startsWith("JVBER")) return "pdf";
  if (base64.startsWith("/9j/") || base64.startsWith("/AAAB")) return "jpeg";
  if (base64.startsWith("iVBOR")) return "png";
  if (base64.startsWith("R0lGOD")) return "gif";
  if (base64.startsWith("UklGR")) return "webp";
  if (base64.startsWith("AAABAAEAAwAA")) return "bmp";
  if (base64.startsWith("SUQz")) return "ico";
  if (base64.startsWith("PHN2")) return "svg";
  if (base64.startsWith("SUkqA") || base64.startsWith("TU0AK")) return "tiff";
  if (base64.startsWith("APNG")) return "apng";
  if (base64.startsWith("AAABAAIAAQI")) return "cur";

  return "unknown";
};

const getMimeType = (extension) => {
  const mimeTypes = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    bmp: "image/bmp",
    gif: "image/gif",
    tiff: "image/tiff",
    txt: "text/plain",
    csv: "text/csv",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.ms-powerpoint",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // Add more as needed
  };

  // switch (fileType.toLowerCase()) {
  //   case ".mp4":
  //     mimeType = "video/mp4";
  //     break;
  //   case ".mp3":
  //     mimeType = "audio/mpeg";
  //     break;
  //   case ".wav":
  //     mimeType = "audio/wav";
  //     break;
  //   case ".ogg":
  //     mimeType = "audio/ogg";
  //     break;
  //   case ".webm":
  //     mimeType = "video/webm";
  //     break;
  //   case ".zip":
  //     mimeType = "application/zip";
  //     break;
  //   case ".json":
  //     mimeType = "application/json";
  //     break;
  //   case ".xml":
  //     mimeType = "application/xml";
  //     break;
  //   case ".html":
  //   case ".htm":
  //     mimeType = "text/html";
  //     break;
  //   // Add more cases for other file types as needed
  //   default:
  //     console.error("Unsupported file type");
  //     return;
  // }

  // Remove leading dot if present
  const cleanExtension = extension.startsWith(".")
    ? extension.slice(1)
    : extension;
  return mimeTypes[cleanExtension.toLowerCase()] || "application/octet-stream"; // Fallback for unknown types
};

export const viewFile = (base64Data, extension) => {
  const fileType = getMimeType(extension);

  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType });

  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl);
};

export const downloadFileWithMime = (base64Data, mimeType, fileName) => {
  const fileType = mimeType;

  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType });

  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(blobUrl); // Clean up the URL
};

export const downloadFile = (base64Data, extension, fileName) => {
  const fileType = getMimeType(extension);

  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType });

  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(blobUrl); // Clean up the URL
};